import { Injectable, signal } from '@angular/core';
import { DateRangePickerOutput, TimeUnit } from '../../../../shared/components/date-picker/date-picker.component';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
const LA_TIMEZONE = 'America/Los_Angeles';

@Injectable({
  providedIn: 'root'
})
export class ArrangmentCronDatePickerService {
  // Shared date picker state
  private _startDate = signal<string>(dayjs.utc().tz(LA_TIMEZONE).subtract(29, 'days').startOf('day').toISOString());
  private _endDate = signal<string>(dayjs.utc().tz(LA_TIMEZONE).endOf('day').toISOString());
  private _unit = signal<TimeUnit>('day');

  // Public readonly signals
  readonly startDate = this._startDate.asReadonly();
  readonly endDate = this._endDate.asReadonly();
  readonly unit = this._unit.asReadonly();

  // Get current date range value for date picker component
  getDatePickerValue() {
    return {
      startDate: this._startDate(),
      endDate: this._endDate(),
      unit: this._unit(),
      comparisonType: 'none' as const
    };
  }

  // Update date range from date picker output
  updateDateRange(output: DateRangePickerOutput): void {
    this._startDate.set(output.start_date);
    this._endDate.set(output.end_date);
    this._unit.set(output.unit);
  }

  // Reset to default values
  reset(): void {
    this._startDate.set(dayjs.utc().tz(LA_TIMEZONE).subtract(30, 'days').startOf('day').toISOString());
    this._endDate.set(dayjs.utc().tz(LA_TIMEZONE).endOf('day').toISOString());
    this._unit.set('day');
  }
}
